import { Component, Input } from "@angular/core";
import { NgxSkeletonLoaderComponent } from "ngx-skeleton-loader";

@Component({
  selector: 'app-skeleton-loader',
  standalone: true,
  imports: [
    NgxSkeletonLoaderComponent
  ],
  templateUrl: './skeleton-loader.component.html',
  styleUrl: './skeleton-loader.component.scss'
})
export class SkeletonLoaderComponent {
  @Input() count: number = 30;
  @Input() appearance: 'line' | 'circle' = 'line';
  @Input() animation: 'progress' | 'pulse' = 'pulse';
  @Input() customTheme: { [key: string]: string } = {};

  get mergedTheme(): { [key: string]: string } {
    return {
      height: '20px',
      width: '100%',
      borderRadius: '8px',
      backgroundColor: 'var(--gray-100)',
      ...this.customTheme
    };
  }

}
